export const ADD_TABLE_SUCCESS = "redux_store:tables.success.add";
export const DELETE_TABLE_SUCCESS = "redux_store:tables.success.delete";
export const UPDATE_TABLE_SUCCESS = "redux_store:tables.success.update";

export const ADD_TABLELINK_SUCCESS = "redux_store:tables.success.add_link";
export const DELETE_TABLELINK_SUCCESS = "redux_store:tables.success.delete_link";
export const UPDATE_TABLELINK_SUCCESS = "redux_store:tables.success.update_link";



// WEBPACK FOOTER //
// ./src/successes/tables.js